module.exports = "<p>\r\n  awsop-lab17 works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab17/awsop-lab17.component.html
// module id = ./src/app/course/labs/awsop/awsop-lab17/awsop-lab17.component.html
// module chunks = main